// extracted by css-extract-rspack-plugin
module.exports =  {"liveBlinker":"vucte","largeSize":"wJGWQ","gogoloader":"FJOFC","relatedLbIcon":"h_5zb"};